var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
;
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Header from '../components/header/Header';
import Footer from '../components/common/footer/Footer';
import Icon from '@material-ui/core/Icon';
import Announcement from '../components/announcement/Announcement';
var drawerWidth = 240;
var SideBarLayout = function (props) {
    var _a, _b;
    var sidebarMenu = props.sidebarMenu;
    var classes = useStyles();
    var theme = useTheme();
    var _c = React.useState(true), open = _c[0], setOpen = _c[1];
    var handleDrawerToggle = function () {
        setOpen(!open);
    };
    var handleDrawerClose = function () {
        setOpen(false);
    };
    return (React.createElement("div", { className: classes.root },
        React.createElement(Header, { isMainLayout: false, toggleSideBar: handleDrawerToggle }),
        React.createElement(Announcement, null),
        React.createElement(Drawer, { variant: "permanent", className: clsx(classes.drawer, (_a = {},
                _a[classes.drawerOpen] = open,
                _a[classes.drawerClose] = !open,
                _a)), classes: {
                paper: clsx((_b = {},
                    _b[classes.drawerOpen] = open,
                    _b[classes.drawerClose] = !open,
                    _b)),
            } },
            React.createElement("div", { className: clsx(classes.toolbar, classes.toolbarWrap) },
                React.createElement(IconButton, { onClick: handleDrawerClose }, theme.direction === 'rtl' ? React.createElement(ChevronRightIcon, null) : React.createElement(ChevronLeftIcon, null))),
            React.createElement(Divider, null),
            React.createElement(List, null, sidebarMenu.map(function (_a, index) {
                var name = _a.name, icon = _a.icon;
                return (React.createElement(ListItem, { button: true, key: index },
                    React.createElement(ListItemIcon, { className: clsx(classes.itemIcon, {
                        // [classes.itemIcon]: open
                        }) },
                        React.createElement(Icon, { className: classes.itemIconSidebar }, icon)),
                    React.createElement(ListItemText, { primary: React.createElement(Typography, { className: classes.itemTextSidebar }, name) })));
            }))),
        React.createElement("main", { className: classes.content },
            React.createElement("div", { className: classes.toolbar }),
            props.children,
            React.createElement(Footer, null))));
};
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        root: {
            display: 'flex',
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        appBarShift: {
            marginLeft: drawerWidth,
            width: "calc(100% - " + drawerWidth + "px)",
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        menuButton: {
            marginRight: 36,
        },
        hide: {
            display: 'none',
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
            whiteSpace: 'nowrap'
        },
        drawerOpen: {
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            borderRight: "1px solid transparent"
        },
        drawerClose: (_a = {
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                overflowX: 'hidden',
                width: theme.spacing(7) + 1
            },
            _a[theme.breakpoints.up('sm')] = {
                width: theme.spacing(7) + 1,
            },
            _a.borderRight = "1px solid transparent",
            _a),
        toolbar: __assign({ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: theme.spacing(0, 1) }, theme.mixins.toolbar),
        toolbarWrap: {
            minHeight: 48
        },
        itemIcon: {
            minWidth: 45
        },
        itemIconSidebar: {
            fontSize: 20
        },
        itemTextSidebar: {
            fontFamily: "'Open Sans', 'Droid Sans', Tahoma, Arial, sans-serif !impotant",
            fontSize: 13
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
        },
    });
});
export default SideBarLayout;
